import { createRouter, Navigate } from '@tanstack/react-router';
import { partsRoute } from './accessories';
import { buffaloRoute } from './buffalo';
import { dashboardRoute } from './dashboard';
import { newDronesRoute } from './drones';
import { indexRoute } from './index';
import { loginRoute } from './loginRoute';
import { powerCitrosRoute } from './power-citros';
import { protectedLayoutRoute } from './protectedLayout';
import { rootRoute } from './routes';
import { usedDronesRoute } from './usedDrones';

const routeTree = rootRoute.addChildren([
  loginRoute,
  protectedLayoutRoute.addChildren([
    indexRoute,
    dashboardRoute,
    newDronesRoute,
    usedDronesRoute,
    buffaloRoute,
    powerCitrosRoute,
    partsRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <Navigate to="/dashboard" replace />,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
